<div class="container" [class]="position">
    {{text}}
</div>
